import { useFormContext, useWatch } from "react-hook-form";

import { QuoteRequestLineFormData } from "#modules/quoteRequestLines/types/QuoteRequestLineFormData";
import { useProcessSteps } from "#modules/quoteRequestLines/views/DetailsPanel/ProcessSteps/useProcessSteps";
import { useProcessStepsSelectData } from "#modules/quoteRequestLines/views/DetailsPanel/ProcessSteps/useProcessStepsSelectData";
import { IndustrialProcessType, MaterialGradeSchema } from "shared";

export const defaultFilterProcessSteps = <T extends { industrialProcess: IndustrialProcessType }>(
  processSteps: T[],
): T[] => processSteps;

export const useProcessStepsSelect = (
  filterProcessSteps: <T extends { industrialProcess: IndustrialProcessType }>(
    processSteps: T[],
  ) => T[] = defaultFilterProcessSteps,
) => {
  const { control } = useFormContext<QuoteRequestLineFormData>();

  const quoteRequestLineId = useWatch({ control, name: "quoteRequestLineId" });
  const materialGrade = useWatch({ control, name: "materialGrade" });

  const { allPredictedProcessSteps, additionalProcessSteps } = useProcessSteps({
    quoteRequestLineId,
    materialGrade: materialGrade ?? MaterialGradeSchema.enum.OTHER,
    filterProcessSteps,
  });

  const { allProcessStepsDataForSelect, getProcessStepToAddFromSelect } = useProcessStepsSelectData(
    {
      allPredictedProcessSteps,
      additionalProcessSteps,
      filterProcessSteps,
      materialGrade: materialGrade ?? MaterialGradeSchema.enum.OTHER,
    },
  );

  return {
    allProcessStepsDataForSelect,
    getProcessStepToAddFromSelect,
    allPredictedProcessSteps,
  };
};
